<template>
    <div class="headlineWithLine">
        <h4> {{ headline }} </h4>
    </div>
</template>

<script>
export default {
    props: {
        headline: String,
        color: String
    },
    mounted () {
        this.$el.classList.add(this.color);
    }
}
</script>

<style lang="scss" scoped>
    @import '../../assets/scss/colors.scss';

    .headlineWithLine {
        position: relative;
        top: -2rem;
        * {
            margin: 0;
        }
        h4 {
            position: relative;
            left: 6rem;
            top: -0.85rem;
        }
        &.dark {
            * {
                color: $dark;
                
            }
            &:before {
                background: $dark !important;
            }
        }

        &.light {
            * {
                color: $port-blue-dark;
            }
            &:before {
                background: $port-blue-dark !important;
            }
        }
        &:before {
            content: '';
            position: absolute;
            display: inline-block;
            width: 5rem;
            height: 2px;
        }
    }
</style>